/**
 * NOTE: Playwright injects hooks on window.__NSAI_E2E_WEBSOCKET__ (see vite-env.d.ts).
 * In production that property is undefined.
 */

export const getE2eMockSocketServerUrl = (): string | undefined => {
  if (globalThis.window === undefined) {
    return undefined;
  }
  return globalThis.window.__NSAI_E2E_WEBSOCKET__?.mockSocketServerUrl;
};

export const consumeE2eForceNextSendMessageThrow = (): boolean => {
  if (globalThis.window === undefined) {
    return false;
  }
  const hooks = globalThis.window.__NSAI_E2E_WEBSOCKET__;
  if (!hooks?.forceNextSendMessageThrow) {
    return false;
  }
  hooks.forceNextSendMessageThrow = false;
  return true;
};

// NOTE: NSAI-5042 — E2E-only timing overrides (see vite-env.d.ts). Each getter
// returns undefined outside Playwright so production always uses the real
// constants.
export const getE2eAckTimeoutMsOverride = (): number | undefined => {
  if (globalThis.window === undefined) {
    return undefined;
  }
  return globalThis.window.__NSAI_E2E_WEBSOCKET__?.ackTimeoutMsOverride;
};

export const getE2eHealthCheckTimeoutMsOverride = (): number | undefined => {
  if (globalThis.window === undefined) {
    return undefined;
  }
  return globalThis.window.__NSAI_E2E_WEBSOCKET__?.healthCheckTimeoutMsOverride;
};

export const getE2eSendStallTimeoutMsOverride = (): number | undefined => {
  if (globalThis.window === undefined) {
    return undefined;
  }
  return globalThis.window.__NSAI_E2E_WEBSOCKET__?.sendStallTimeoutMsOverride;
};
